import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem('synclothe_cookie_consent');
      if (!consent) {
        setIsVisible(true);
      }
    } catch {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem('synclothe_cookie_consent', 'accepted');
    } catch (e) {
      console.warn('Unable to persist cookie consent to localStorage', e);
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie and Local Storage Policy"
      className="fixed bottom-0 left-0 right-0 z-[9998] p-4 bg-[#05070c]/95 backdrop-blur-xl border-t-2 border-azure-500/40 shadow-[0_-10px_40px_rgba(0,0,0,0.8)] animate-slide-up"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-start gap-3.5 text-left">
          <div className="w-9 h-9 rounded-xl bg-azure/10 border border-azure-500/30 flex items-center justify-center text-azure-400 shrink-0 mt-0.5">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <div className="space-y-1">
            <div className="flex items-center gap-2">
              <span className="text-[10px] font-black uppercase tracking-widest text-gold">Storage & Privacy Notice</span>
              <span className="text-[8px] font-mono text-gray-400 uppercase tracking-wider">EU ePrivacy & GDPR Compliant</span>
            </div>
            <p className="text-xs text-gray-300 leading-relaxed font-medium max-w-3xl">
              Synclothe utilizes essential authentication session cookies (<code className="text-azure-300 bg-white/5 px-1 py-0.5 rounded text-[11px]">StaticWebAppsAuthCookie</code>) and local device storage (<code className="text-azure-300 bg-white/5 px-1 py-0.5 rounded text-[11px]">localStorage</code>) to maintain styling preferences, digital closet caches, and secure user states.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3 w-full md:w-auto shrink-0 justify-end">
          <Link
            to="/privacy"
            className="text-[11px] font-bold text-gray-400 hover:text-white uppercase tracking-wider px-3 py-2 transition-colors whitespace-nowrap"
          >
            Review Policy
          </Link>
          <button
            type="button"
            onClick={handleAccept}
            className="btn-azure text-xs font-black uppercase tracking-widest py-2.5 px-6 rounded-xl shadow-lg shadow-azure/20 hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
          >
            Acknowledge & Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
